import { render, staticRenderFns } from "./ClassManagePage.vue?vue&type=template&id=28a5c0b3&scoped=true&"
import script from "./ClassManagePage.vue?vue&type=script&lang=js&"
export * from "./ClassManagePage.vue?vue&type=script&lang=js&"
import style0 from "./ClassManagePage.vue?vue&type=style&index=0&id=28a5c0b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5c0b3",
  null
  
)

export default component.exports